module.exports = __webpack_public_path__ + "google-rounded-db12e08a66b4c69ebea8.svg";